import React, { useRef, useState, Fragment } from 'react';
// import { Link } from 'react-router-dom';
// import style from './style.css';
// import { Icon } from '../../Icon';
import cx from '../../../../styles';
import { translate } from 'react-i18next';
import NotificationSystem from 'react-notification-system';
import { template } from '../../../../config/index'

export const ResponseBar = ({ isReply, likes, dislikes, replyCount, onLikeClick, onDislikeClick, onReplyClick, onShareClick, ifTapPoll, inFeed, t, url = '', botIndex = false, status, replyStatus, likeErrorMessage }) => {
    /*let replyVerb, likeVerb;

    if (isReply) {
        replyVerb = replyCount > 1 ? t('detail_reply_count_plural') : t('detail_reply_count');
        likeVerb = likes.count > 1 ? t('community_like_plural') : t('community_like');
    } else {
        replyVerb = replyCount > 1 ? t('detail_comment_count_plural') : t('detail_comment_count');
        likeVerb = likes.count > 1 ? t('community_like_plural') : t('community_like');
    }*/
    const [isShowNotification, setShowNotification] = useState(true);
    const notificationSystem = useRef();
    let relValue = {};
    if (!botIndex) {
        relValue = {
            rel: "nofollow"
        };
    }
    const addNotification = (message) => {
        if (isShowNotification) {
            setShowNotification(false);
            const notification = notificationSystem.current;
            notification.addNotification({
                message: message,
                level: 'error',
                autoDismiss: 3,
                position: 'tc'
            });
            setTimeout(() => {
                setShowNotification(true)
            }, 3000)
        }
    }

    const likeClickEvent = (message) => {
        onLikeClick();
        if (message) {
            addNotification(message)
        }
    }

    const replyDislikeClickEvent = (message) => {
        onDislikeClick();
        if (message) {
            addNotification(message)
        }
    }

    return (
        <Fragment>
            <NotificationSystem ref={notificationSystem} />
            <div className={cx("response-bar")}>
                <aside className={cx("left")}>
                    {
                        isReply && !ifTapPoll &&
                        <p onClick={() => likeClickEvent(likeErrorMessage)} className={cx("pointer-click")}>
                            {/*<Icon name={!likes.liked ? 'upvote-icon' : 'upvote-filled-icon'} />*/}
                            <span className={cx('response-sprite', template, !likes.liked ? 'upvote-icon' : 'upvote-filled-icon')}></span>
                            {likes.count != 0 && <span className={cx("count")}>{likes.count}&nbsp;</span>}
                            {!dislikes && <span>{t('detail_upvote')}</span>}
                        </p>
                    }

                    {
                        isReply && !ifTapPoll && dislikes &&
                        <p onClick={() => replyDislikeClickEvent(likeErrorMessage)} className={cx("pointer-click")}>
                            {/*<Icon name={!dislikes.disliked ? 'downvote-icon' : 'downvote-filled-icon'} />*/}
                            <span className={cx('response-sprite', template, !dislikes.disliked ? 'downvote-icon' : 'downvote-filled-icon')}></span>
                        </p>
                    }

                    {
                        !isReply && !ifTapPoll &&
                        <p onClick={() => likeClickEvent(likeErrorMessage)} className={cx("pointer-click")}>
                            {/*<Icon name={!likes.liked ? 'heart-gray-icon' : 'heart-red-icon'} />*/}
                            <span className={cx('response-sprite', template, !likes.liked ? 'heart-gray-icon' : 'heart-red-icon')}></span>
                            {likes.count != 0 && <span className={cx("count")}>{likes.count}&nbsp;</span>}
                            <span>{t('community_like')}</span>
                        </p>
                    }

                    {!isReply && !inFeed && !ifTapPoll &&
                        <p onClick={() => onReplyClick()} className={cx("pointer-click")} >
                            {/*<Icon name='comment-icon' />*/}
                            <span className={cx('response-sprite', template, 'comment-icon')}></span>
                            {replyCount != 0 && <span className={cx("count")}>{replyCount}&nbsp;</span>}
                            <span>{isReply ? t('detail_comment_count') : t('detail_reply_count')}</span>
                        </p>
                    }
                    {
                        !isReply && inFeed && !ifTapPoll &&
                        <a href={url} onClick={(e) => { e.preventDefault(); onReplyClick(); }} className={cx("pointer-click")} {...relValue} >
                            {/*<Icon name='comment-icon' />*/}
                            <span className={cx('response-sprite', template, 'comment-icon')}></span>
                            {replyCount != 0 && <span className={cx("count")}>{replyCount}&nbsp;</span>}
                            <span>{isReply ? t('detail_comment_count') : t('detail_reply_count')}</span>
                        </a>
                    }
                </aside>
                <aside className={cx("right")}>
                    {isReply && !inFeed && !ifTapPoll &&
                        <p onClick={() => onReplyClick()} className={cx("pointer-click")} >
                            {/*<Icon name='comment-icon' />*/}
                            <span className={cx('response-sprite', template, 'comment-icon')}></span>
                            {replyCount != 0 && <span className={cx("count")}>{replyCount}&nbsp;</span>}
                            <span>{isReply ? t('detail_comment_count') : t('detail_reply_count')}</span>
                        </p>
                    }
                    {
                        isReply && inFeed && !ifTapPoll &&
                        <a href={url} onClick={(e) => { e.preventDefault(); onReplyClick(); }} className={cx("pointer-click")} {...relValue} >
                            {/*<Icon name='comment-icon' />*/}
                            <span className={cx('response-sprite', template, 'comment-icon')}></span>
                            {replyCount != 0 && <span className={cx("count")}>{replyCount}&nbsp;</span>}
                            <span>{isReply ? t('detail_comment_count') : t('detail_reply_count')}</span>
                        </a>
                    }
                    {
                        !ifTapPoll && status == 1 && replyStatus == 1 &&
                        <p onClick={onShareClick} className={cx("pointer-click")}>
                            {/*<Icon name='share-new-icon' />*/}
                            <span className={cx('response-sprite', template, 'share-icon')}></span>
                            <span>{t('detail_share')}</span>
                        </p>
                    }
                </aside>
            </div>
        </Fragment>
    )
}

export default translate()(ResponseBar);